import {spacing} from '@/theme/spacing'
import {MAX_SCREEN_WIDTH} from '@/theme/theme'
import styled from 'styled-components'

export const FilterBar = styled.nav`
    position: sticky;
    top: 0;
    z-index: 999;
    display: flex;
    width: 100%;
    background-color: ${(props) => props.theme.navigationResponsive.dataArea.background};
    color: ${(props) => props.theme.navigationResponsive.dataArea.textColor};
`

export const NavBar = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
`

export const Content = styled.div`
    border-top: 1px solid white;
    padding: ${spacing(1)} 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    @media (max-width: ${MAX_SCREEN_WIDTH}px) {
        padding-inline: 16px;
    }
`

export const VesselFilterButton = styled.div`
    width: 100%;

    max-width: 500px;

    button {
        width: 100%;
    }

    button > div:first-child {
        overflow-x: auto;
        overflow-y: hidden;

        &::-webkit-scrollbar {
            height: 4px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background: ${({theme}) => theme.colors.border.default};
            border-radius: 2px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: ${({theme}) => theme.colors.border.active};
        }
    }
`
